/**
 * @file DeliveryPackageItemRow.tsx
 * @description Строка позиции в раскладке по местам (phase19.12 шаг 5).
 *
 * Показывает данные из карточки товара — вес за штуку и габариты — чтобы
 * менеджер глазами проверил расчёт места. Чего в товаре нет, то и написано
 * янтарным: сразу видно, почему авто-расчёт не сработал и что заполнить.
 */

import { Checkbox } from "../ui/checkbox";
import type { OrderDeliveryLineDto } from "../../lib/api-orders";
import { formatDims, formatWeight } from "../../lib/delivery-quote";

interface Props {
  item: OrderDeliveryLineDto;
  checked: boolean;
  /** Номер места, в котором позиция уже лежит (тогда чекбокс заблокирован). */
  placedIn?: number;
  disabled?: boolean;
  onToggle: (checked: boolean) => void;
}

export function DeliveryPackageItemRow({
  item,
  checked,
  placedIn,
  disabled,
  onToggle,
}: Props) {
  const blocked = !checked && placedIn !== undefined;
  const dims = formatDims(item.lengthMm, item.widthMm, item.heightMm);
  const hasWeight = item.weightG !== null && item.weightG !== undefined;

  return (
    <label className="flex min-h-11 items-start gap-2 py-1 text-sm">
      <Checkbox
        className="mt-1"
        checked={checked}
        disabled={disabled || blocked}
        onCheckedChange={(next) => onToggle(next)}
      />
      <span className={`min-w-0 flex-1 ${blocked ? "text-on-surface-variant" : ""}`}>
        <span className="block">
          {item.name} · {item.quantity} шт.
          {blocked ? ` — в месте ${placedIn}` : ""}
        </span>
        {/* Вторая строка: данные товара. На 360px переносится сама. */}
        <span className="block text-xs text-on-surface-variant">
          {hasWeight ? (
            `${formatWeight(item.weightG)}/шт`
          ) : (
            <span className="text-warning">вес не заполнен</span>
          )}
          {" · "}
          {dims ?? <span className="text-warning">габариты не заполнены</span>}
        </span>
      </span>
    </label>
  );
}
